/* eslint-disable import/no-namespace */
import _ from 'lodash';
import moment from 'moment';
import * as types from '../../actions';
import isEmpty from '../../../utils/functions/isEmpty';
import { resetposteventfields, StatusDescription } from '../../../utils/constants';

const POST_EVENT_TYPES = types.types.PostEvent;
const SEASON_TYPES = types.types.Season;

const resetmember = {
  memberName: '',
  email: '',
  memberState: '',
  city: '',
  calculatedAge: '',
  gender: '',
  calculatedDivision: '',
  parentEmail: '',
  memberRetrieved: false,
  membershipPurchaseDate: ''
};

function getEventEligibleSeasons(seasons) {
  return _.filter(seasons, {
    isSeasonSet: true
  })
}

const calculateDivision = function (stateValues, memberDOB, memberGender) {
  const { mixedAgeDivisionsHeld, divisionHeldId } = stateValues
  let divisions = [];

  if (divisionHeldId !== undefined) {
    divisions = _.find(mixedAgeDivisionsHeld, { id: parseInt(divisionHeldId) }).divisions;
  }

  if (divisions.length > 0 && !isEmpty(memberDOB) && !isEmpty(memberGender)) {
    const divisionsFilteredByDOB = divisions.filter(d => moment(d.dobStart) <= moment(memberDOB) && moment(d.dobEnd) >= moment(memberDOB));
    const divisionsFilteredByGender = divisionsFilteredByDOB.filter(d => d.gender === memberGender || d.gender === 'FM');

    if (divisionsFilteredByGender.length > 0) {
      return divisionsFilteredByGender[0];
    }
    else {
      return;
    }
  }
  else {
    return;
  }
}

const findDivisionMatch = function (stateValues, division) {
  const { mixedAgeDivisionsHeld, divisionHeldId } = stateValues

  if (divisionHeldId !== undefined && divisionHeldId !== '-1' && division !== null && division !== undefined) {
    const divisions = _.find(mixedAgeDivisionsHeld, { id: parseInt(divisionHeldId) }).divisions;
    const matchingRecords = divisions.filter(d => d.id === division.id);
    if (matchingRecords.length > 0) {
      return matchingRecords[0];
    }
    else {
      return;
    }
  }
  else {
    return;
  }
}

const createMixedAgeDivision = function (stateValues) {
  const { seasons, eventseason, mixedAgeDivisionsHeld } = stateValues;
  const seasonDivisions = _.find(seasons, { id: parseInt(eventseason) }).divisions;
  const divisions = [...mixedAgeDivisionsHeld];
  const selectedParents = mixedAgeDivisionsHeld.filter(f => f.id > 0);
  const idsIndivisionsSelected = (selectedParents.map(division => division.divisions)).map((item) => (
    item.map((inneritem) => (inneritem.id))
  ));
  const flatteneSaveddArray = [].concat(...idsIndivisionsSelected);
  const unsavedDivisions = ((mixedAgeDivisionsHeld.filter(f => f.id === 0)).map(division => division.divisions)).map((item) => (
    item.map((inneritem) => (inneritem))
  ));
  const unsavedSelectedIds = unsavedDivisions.map(ud => ud.filter(f => f.selected === true)).map((divisions) => (
    divisions.map((division) => (division.id))
  ));
  const flattenedUnsavedArray = [].concat(...unsavedSelectedIds);
  const allSelectedDivisions = [...flatteneSaveddArray, ...flattenedUnsavedArray];
  const filteredseasonDivisions = seasonDivisions.filter(seasonDivision => !allSelectedDivisions.includes(seasonDivision.id));
  const entry = {
    id: 0,
    name: '',
    held: ' ',
    advancerRatio: 1,
    divisions: []
  };
  filteredseasonDivisions.map((div) => {
    entry.divisions.push({
      id: div.id,
      name: div.name,
      selected: false
    });
  })
  divisions.push(entry);
  return divisions;

}

export default function postevent(state = {}, action) {

  switch (action.type) {

    case POST_EVENT_TYPES.OPT_OUT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            refreshSearchBar: true
          },
          fields: {
            ...state.fields,
            refreshSearchBar: true
          }
        }
      }
    case POST_EVENT_TYPES.FETCH_ALTERNATE_PARENT_EMAIL:
      {
        if (action.payload.data !== undefined) {
          const { parentEmailAddress } = action.payload.data;

          return {
            ...state,
            values: {
              ...state.values,
              parentEmailAddress
            },
            fields: {
              ...state.fields,
              parentEmailAddress: parentEmailAddress
            }
          }
        }
        return state;
      }
    case POST_EVENT_TYPES.FETCH_ADVANCER_PARENT_EMAIL:
      {
        if (action.payload.data !== undefined) {
          const { parentEmailAddress } = action.payload.data;

          return {
            ...state,
            values: {
              ...state.values,
              parentEmailAddress
            },
            fields: {
              ...state.fields,
              parentEmailAddress: parentEmailAddress
            }
          }
        }
        return state;
      }
    case POST_EVENT_TYPES.FETCH_POST_EVENT:
      {
        if (action.payload.data !== undefined) {
          const {
            currentWizardStep,
            lastStepCompleted,
            eventInfo,
            payments,
            status,
            postEventSetup
          } = action.payload.data;

          const {
            eventId,
            eventTypeId,
            seasonId,
            name,
            resultsSubmittedOn,
            advancerEmailsSentOn
          } = eventInfo;

          const info = {
            status: status,
            advancerEmailsSentOn: advancerEmailsSentOn
          }

          const {
            useMajorFraction,
            mixedAgeDivisionsHeld,
            advancerRatio,
          } = postEventSetup;

          const eventRetrieved = true;
          const numberSpots = 0;
          const prestineinfo = info;

          return {
            ...state,
            values: {
              ...state.values,
              ...info,
              eventId,
              prestineinfo,
              eventTypeId,
              eventname: name,
              currentWizardStep: currentWizardStep,
              lastStepCompleted: lastStepCompleted,
              fetchingevent: false,
              eventRetrieved,
              resultsUploadedOn: resultsSubmittedOn,
              numberSpots: numberSpots,
              paymentError: '',
              useMajorFraction: useMajorFraction,
              mixedAgeDivisionsHeld: mixedAgeDivisionsHeld,
              advancerRatio: advancerRatio,
              eventseason: seasonId,
              updateSetupErrors: {},
              updateRecordAdvancersErrors: {},
              updatePaymentErrors: {},
              divisionHeldId: 0,
              payments
            },
            fields: {
              ...state.fields,
              ...info,
              prestineinfo,
              eventId,
              eventTypeId,
              eventname: name,
              currentWizardStep: currentWizardStep,
              lastStepCompleted: lastStepCompleted,
              fetchingevent: false,
              eventRetrieved,
              resultsUploadedOn: resultsSubmittedOn,
              numberSpots: numberSpots,
              paymentError: '',
              useMajorFraction: useMajorFraction,
              mixedAgeDivisionsHeld: mixedAgeDivisionsHeld,
              advancerRatio: advancerRatio,
              eventseason: seasonId,
              updateSetupErrors: {},
              updateRecordAdvancersErrors: {},
              updatePaymentErrors: {},
              divisionHeldId: 0,
              payments
            }
          }
        }
        return state
      }
    case POST_EVENT_TYPES.FETCHING_POST_EVENT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            fetchingevent: true
          },
          fields: {
            ...state.fields,
            fetchingevent: true
          }
        }
      }
    case POST_EVENT_TYPES.RESET_WIZARD_STATE:
      {
        const wizardstate = {
          currentWizardStep: action.payload,
          saveComponentState: false,
          componentStateSaved: false
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...wizardstate
          },
          fields: {
            ...state.fields,
            ...wizardstate
          }
        }
      }
    case POST_EVENT_TYPES.RESET_POST_EVENT_WIZARD: {
      return {
        ...state,
        values: {
          ...state.values,
          ...resetposteventfields
        },
        fields: {
          ...state.fields,
          ...resetposteventfields
        }
      }
    }
    case POST_EVENT_TYPES.UPLOADING_RESULTS_FILE:
      {
        return {
          ...state,
          values: {
            ...state.values,
            uploadingResults: true,
            successfileUpload: false,
          },
          fields: {
            ...state.fields,
            uploadingResults: true,
            successfileUpload: false,
          }
        }
      }
    case POST_EVENT_TYPES.UPLOAD_RESULTS_FILE:
      {
        if (action.payload !== undefined) {
          const uploadResponse = action.payload;
          let resultsUploadedOn = null;
          if (uploadResponse !== undefined) {
            resultsUploadedOn = uploadResponse.data.resultsUploadedOn;
          }
          return {
            ...state,
            values: {
              ...state.values,
              uploadingResults: false,
              successfileUpload: true,
              componentStateSaved: true,
              resultsUploadedOn
            },
            fields: {
              ...state.fields,
              uploadingResults: false,
              successfileUpload: true,
              componentStateSaved: true,
              resultsUploadedOn
            }
          }
        } else {
          return state
        }
      }
    case POST_EVENT_TYPES.PRESTINE_NAVIGATE_NEXT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            componentStateSaved: true,
          },
          fields: {
            ...state.fields,
            componentStateSaved: true,
          }
        }
      }
    case POST_EVENT_TYPES.SET_SEARCH_MODE:
      {
        const searchMode = action.payload;
        return {
          ...state,
          values: {
            ...state.values,
            searchMode,
          },
          fields: {
            ...state.fields,
            searchMode,
          }
        }
      }
    case POST_EVENT_TYPES.FETCH_MEMBER:
      {
        if (action.payload.statusCode === 404 || action.payload.value.Results[0] === undefined) {
          return {
            ...state,
            values: {
              ...state.values,
              ...resetmember,
              norecordsfound: true,
              searchMode: false
            },
            fields: {
              ...state.fields,
              ...resetmember,
              norecordsfound: true,
              searchMode: false
            }
          }
        } else {
          const member = action.payload.value.Results[0]

          const division = calculateDivision(state.values, member.birthday, member.gender);
          const match = findDivisionMatch(state.values, division);

          const details = {
            memberName: member.first + ' ' + member.init + ' ' + member.last,
            address1: member.address1,
            address2: member.address2,
            birthDate: !isEmpty(member.birthday) ? moment(member.birthday).format('LL') : '',
            city: member.city,
            country: member.country,
            phoneNumber: member.phone,
            email: member.email,
            firstName: member.first,
            lastName: member.last,
            memberState: member.state,
            zip: member.zip,
            calculatedAge: !isEmpty(member.birthday) ? moment().diff(member.birthday, 'years') : '',
            calculatedDivision: division !== null && division !== undefined ? division.name : '',
            calculatedDivisionId: match != null && match !== undefined ? match.id : '',
            gender: member.gender,
            searchMode: false,
            memberRetrieved: true,
            isBaseActive: member.isbaseactive,
            isJuniorGoldActive: member.isjuniorgoldactive,
            isCollegiateAdult: member.iscollegiateadult,
            isCollegiateYouth: member.iscollegiateyouth,
            isJuniorGoldU12: member.isjuniorgoldu12,
            isJuniorGoldU14: member.isJuniorGoldU14,
            isJuniorGoldU16: member.isJuniorGoldU16,
            isJuniorGoldU18: member.isJuniorGoldU18,
            isJuniorGoldU20: member.isjuniorgoldu20,
            isJuniorGoldU15U18: member.isjuniorgoldu15U18,
            isJuniorGoldU15U17U20: member.isjuniorgoldu15u17u20,
            isSpecialOlympicsAdult: member.isspecialolympicsadult,
            isSpecialOlympicsYouth: member.isspecialolympicsyouth,
            isStandardAdult: member.isstandardadult,
            isStandardYouth: member.isstandardyouth,
            membershipPurchaseDate: !isEmpty(member.juniorgoldgoodthroughdate) ? moment(member.juniorgoldgoodthroughdate).format('LL') : '',
            middleInitial: member.init,
            suffix: member.lineage,
            norecordsfound: false
          }
          if (member) {
            return {
              ...state,
              values: {
                ...state.values,
                ...details
              },
              fields: {
                ...state.fields,
                ...details
              }
            }
          } else {
            return state
          }
        }
      }
    case POST_EVENT_TYPES.SAVING_ATHLETE:
      {
        const response = {
          savingathlete: true,
          newathletesaved: false,
        }
        return {
          ...state,
          values: {
            ...state.values,
            ...response
          },
          fields: {
            ...state.fields,
            ...response
          }
        }
      }
    case POST_EVENT_TYPES.SAVE_ADVANCER:
      {
        if (action.payload != undefined) {

          const mixedagedivisionsheld = action.payload.mixedAgeDivisionsHeldModel;
          const isadvancercurrrently = action.payload.isAdvancerCurrently;

          const response = {
            savingathlete: false,
            newathletesaved: (isadvancercurrrently === 0),
            mixedAgeDivisionsHeld: mixedagedivisionsheld,
            isAdvancerCurrently: isadvancercurrrently
          }
          return {
            ...state,
            values: {
              ...state.values,
              ...response,
              isAdvancerCurrently: action.payload.isAdvancerCurrently
            },
            fields: {
              ...state.fields,
              ...response,
              isAdvancerCurrently: action.payload.isAdvancerCurrently
            }
          }
        } else {
          return state;
        }
      }
    case POST_EVENT_TYPES.SAVE_ALTERNATE:
      {
        if (action.payload != undefined) {

          const mixedagedivisionsheld = action.payload.mixedAgeDivisionsHeldModel;
          const isadvancercurrrently = action.payload.isAdvancerCurrently;

          const response = {
            savingathlete: false,
            newathletesaved: (isadvancercurrrently === 0),
            mixedAgeDivisionsHeld: mixedagedivisionsheld,
            isAdvancerCurrently: isadvancercurrrently
          }
          return {
            ...state,
            values: {
              ...state.values,
              ...response,
              isAdvancerCurrently: action.payload.isAdvancerCurrently
            },
            fields: {
              ...state.fields,
              ...response,
              isAdvancerCurrently: action.payload.isAdvancerCurrently
            }
          }
        } else {
          return state;
        }
      }
    case POST_EVENT_TYPES.DELETE_ADVANCER:
      {
        if (action.payload != undefined) {
          const response = {
            mixedAgeDivisionsHeld: action.payload
          }
          return {
            ...state,
            values: {
              ...state.values,
              ...response
            },
            fields: {
              ...state.fields,
              ...response
            }
          }
        } else {
          return state;
        }
      }
    case POST_EVENT_TYPES.DELETE_ALTERNATE:
      {
        if (action.payload != undefined) {
          const response = {
            mixedAgeDivisionsHeld: action.payload
          }
          return {
            ...state,
            values: {
              ...state.values,
              ...response
            },
            fields: {
              ...state.fields,
              ...response
            }
          }
        } else {
          return state;
        }
      }
    case POST_EVENT_TYPES.SAVE_FEE_PAYMENT:
      {
        if (action.payload) {

          const { errors, data, payments } = action.payload;
          const updatePaymentErrors = errors.description !== null ? errors.description : {};
          const paymentError = errors.description !== null ? errors.description[0] : '';
          const paymentDate = paymentError === '' ? moment(data.paymentDate).format('LL') : '';
          const paymentAmount = data.paymentAmount;
          const paymentConfirmation = data.paymentConfirmation;

          const response = {
            savingPayment: false,
            paymentError,
            paymentDate,
            paymentAmount,
            paymentConfirmation,
            payments,
            updatePaymentErrors
          }
          return {
            ...state,
            values: {
              ...state.values,
              ...response,
            },
            fields: {
              ...state.fields,
              ...response,
            }
          }
        } else {
          return state
        }
      }
    case POST_EVENT_TYPES.SAVE_FEE_PAYMENT_ERROR:
      {
        if (action.payload) {
          const { data } = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              updatePaymentErrors: data,
              savingPayment: false
            },
            fields: {
              ...state.fields,
              updatePaymentErrors: data,
              savingPayment: false
            }
          }
        } else {
          return state
        }
      }
    case POST_EVENT_TYPES.SAVING_FEE_PAYMENT:
      {
        return {
          ...state,
          values: {
            ...state.values,
            savingPayment: true,
          },
          fields: {
            ...state.fields,
            savingPayment: true,
          }
        }
      }
    case POST_EVENT_TYPES.ADD_MIXED_AGE_DIVISION:
      {
        const mixedAgeDivisionsHeld = createMixedAgeDivision(state.values);
        return {
          ...state,
          values: {
            ...state.values,
            mixedAgeDivisionsHeld,
          },
          fields: {
            ...state.fields,
            mixedAgeDivisionsHeld,
          }
        }

      }
    case SEASON_TYPES.FETCH_ACTIVE_SEASONS:
      {
        const seasons = action.payload.data
        let eventSeasons

        if (seasons && state) {

          eventSeasons = getEventEligibleSeasons(seasons)

          return {
            ...state,
            values: {
              ...state.values,
              seasons: eventSeasons
            },
            fields: {
              ...state.fields,
              seasons: eventSeasons
            }
          }
        }
        return state
      }

    case POST_EVENT_TYPES.SAVE_POST_EVENT_SETUP:
      {
        if (action.payload != undefined) {
          const mixedAgeDivisionsHeld = action.payload;

          return {
            ...state,
            values: {
              ...state.values,
              mixedAgeDivisionsHeld: mixedAgeDivisionsHeld,
              componentStateSaved: true,
              updateSetupErrors: {}
            },
            fields: {
              ...state.fields,
              mixedAgeDivisionsHeld: mixedAgeDivisionsHeld,
              componentStateSaved: true,
              updateSetupErrors: {}
            }
          }
        } else {
          return state
        }
      }

    case POST_EVENT_TYPES.SAVE_POST_EVENT_SETUP_ERROR:
      {
        if (action.payload) {
          const { data } = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              updateSetupErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            },
            fields: {
              ...state.fields,
              updateSetupErrors: data,
              updateErrors: data,
              componentStateSaved: false,
              saveComponentState: false,
            }
          }
        } else {
          return state
        }
      }

    case POST_EVENT_TYPES.DELETE_EVENT_DIVISION_HELD:
      {
        if (action.payload) {
          const data = action.payload;

          return {
            ...state,
            values: {
              ...state.values,
              mixedAgeDivisionsHeld: data
            },
            fields: {
              ...state.fields,
              mixedAgeDivisionsHeld: data
            }
          }
        }
        else {
          return state;
        }
      }

    case POST_EVENT_TYPES.SAVE_POST_EVENT_ADVANCERS:
      {
        return {
          ...state,
          values: {
            ...state.values,
            componentStateSaved: true,
            saveComponentState: true,
            updateRecordAdvancersErrors: {}
          },
          fields: {
            ...state.fields,
            componentStateSaved: true,
            saveComponentState: true,
            updateRecordAdvancersErrors: {}
          }
        }
      }

    case POST_EVENT_TYPES.SAVE_POST_EVENT_ADVANCERS_ERROR:
      {
        if (action.payload) {
          return {
            ...state,
            values: {
              ...state.values,
              updateRecordAdvancersErrors: action.payload.data,
              componentStateSaved: false,
              saveComponentState: false,
            },
            fields: {
              ...state.fields,
              updateRecordAdvancersErrors: action.payload.data,
              componentStateSaved: false,
              saveComponentState: false,
            }
          }
        } else {
          return state
        }
      }

    case POST_EVENT_TYPES.UPDATING_ATHLETES:
      {
        return {
          ...state,
          values: {
            ...state.values,
            searchMode: true,
          },
          fields: {
            ...state.fields,
            searchMode: true,
          }
        }
      }

    case POST_EVENT_TYPES.FETCHING_ADVANCERS:
      {
        return {
          ...state,
          values: {
            ...state.values,
            searching: true,
          },
          fields: {
            ...state.fields,
            searching: true,
          }
        }
      }

    case POST_EVENT_TYPES.FETCH_ADVANCERS:
      {
        if (action.payload !== undefined) {
          const advancers = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              advancers,
              searching: false,
              refreshSearchBar: false
            },
            fields: {
              ...state.fields,
              advancers,
              searching: false,
              refreshSearchBar: false
            }
          }
        }
        return state;
      }

    case POST_EVENT_TYPES.TRIGGERING_ADVANCER_PROCESS:
      {
        return {
          ...state,
          values: {
            ...state.values,
            runningProcess: true,
          },
          fields: {
            ...state.fields,
            runningProcess: true,
          }
        }
      }

    case POST_EVENT_TYPES.TRIGGER_ADVANCER_PROCESS:
      {
        if (action.payload !== undefined) {
          const advancers = action.payload;
          return {
            ...state,
            values: {
              ...state.values,
              advancers,
              runningProcess: false,
              refreshSearchBar: true
            },
            fields: {
              ...state.fields,
              advancers,
              runningProcess: false,
              refreshSearchBar: true
            }
          }
        }
        return state;
      }

    case POST_EVENT_TYPES.COMPLETE_EVENT:
      {
        if (action.payload !== undefined) {
          return {
            ...state,
            values: {
              ...state.values,
              status: StatusDescription.Completed
            },
            fields: {
              ...state.fields,
              status: StatusDescription.Completed
            }
          }
        }
        return state;
      }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/postevent.js